/**
 * IMPORTANT:
 * For clarity, do not format this file with an automatic code-formatter.
 * Otherwise you may lose all the indentations.
 */
export class RouteEnum {
  LOGIN = "login";
  MAIN = "main";
  INBOX = "inbox";
  INBOX_VIEW = "inbox-view";
  ORDER = "order";
  ORDER_RX = "rx";
  ORDER_RX_CREATE = "create-rx";
  DASHBOARD = "dashboard";
  REPORTS = "reports";
  SUPPLIES = "supplies";
  USERS = "users";
  MNG = "mng";
  MNG_CLINICS = "clinics";
  MNG_USERS = "users";
  MNG_PARAMS = "params";
  MNG_DR_PROFILE = "dr-profile";
  operation_REPORTS = "operation-reports";
  KPI = "kpi";
  KPI_CLINICS = "kpi-clinics";
  KPI_BROSH = "brosh";
  KPI_AGENTS = "agents";
  AGENT_TASKS = "agent-tasks";
  NOTES_CATALOG = "notes-catalog";
  DELIVERY_WAYBILLS = "delivery-waybills";

  private urlMain = this.MAIN + "/";
  private urlInbox = this.MAIN + "/" + this.INBOX + "/";
  URL_INBOX = this.urlMain + this.INBOX;
  URL_INBOX_VIEW = this.urlInbox + this.INBOX_VIEW;
  URL_ORDER = this.urlInbox + this.ORDER;
  URL_ORDER_RX = this.urlInbox + this.ORDER + "/" + this.ORDER_RX;
  URL_ORDER_RX_CREATE = this.urlInbox + this.ORDER + "/" + this.ORDER_RX_CREATE;
  URL_DASHBOARD = this.urlMain + this.DASHBOARD;
  URL_REPORTS = this.urlMain + this.REPORTS;
  URL_SUPPLIES = this.urlMain + this.SUPPLIES;
  URL_AGENT_TASKS = this.urlMain + this.AGENT_TASKS;
  URL_USERS = this.urlMain + this.USERS;
  private urlMng = this.urlMain + this.MNG + "/";
  URL_MNG = this.urlMng;
  URL_MNG_CLINICS = this.urlMng + this.MNG_CLINICS;
  URL_MNG_USERS = this.urlMng + this.MNG_USERS;
  URL_MNG_PARAMS = this.urlMng + this.MNG_PARAMS;
  URL_MNG_DR_PROFILE = this.urlMng + this.MNG_DR_PROFILE;
  URL_operation_REPORTS = this.urlMain + this.operation_REPORTS;
  private urlKpi = this.urlMain + this.KPI + "/";
  URL_KPI = this.urlKpi;
  URL_KPI_BROSH = this.urlKpi + this.KPI_BROSH;
  URL_KPI_CLINICS = this.urlKpi + this.KPI_CLINICS;
  URL_KPI_AGENTS = this.urlKpi + this.KPI_AGENTS;
  URL_NOTES_CATALOG = this.urlMain + this.NOTES_CATALOG;
  URL_DELIVERY_WAYBILLS = this.urlMain + this.DELIVERY_WAYBILLS;
}

export const routeEnum = Object.freeze(new RouteEnum());
